import React, { useState, useEffect, useRef } from "react";
import { useNavigate, useParams } from "react-router-dom";
import Select from "react-select";
import Response_Processing from "../../../../src/layout/Others/Response_Processing";
import AdminSwitch from "../../../components/CommonComponents/AdminSwitch";
import AdminBackNavigation from "../../../components/CommonComponents/AdminBackNavigation";
import { toast } from "react-toastify";
import MessageLabel from "../../../components/CommonComponents/MessageLabel";
import { useMyContext } from "../../../components/Provider/CommonProvider";
import AdminImageUploadZone from "../../../components/CommonComponents/AdminImageUploadZone";

function EditManageAge(props) {
  const { fetchRequest, globalImageUplaodAPI } = useMyContext();
  const { id } = useParams();
  const navigate = useNavigate();
  const [editUser, setEditUser] = useState({
    id: "",
    age: "",
    slug: "",
    active: "",
  });
  const [ratingLogo, setRatingLogo] = useState(null);
  const [logoPreview, setLogoPreview] = useState(null);
  const [data, setData] = useState([]);
  const [message, setMessage] = useState("");
  const [classificationOptions, setClassificationOptions] = useState([]);
  const [selectedClassifications, setSelectedClassifications] = useState([]);
  const access_token = localStorage.getItem("access_token");

  // console.log(access_token)

  const headers = {
    "Content-Type": "application/json",
    Authorization: "Bearer " + access_token,
    Accept: "application/json",
    "Access-Control-Allow-Origin": "*",
  };
  useEffect(() => {
    const fetchClassifications = async () => {
      try {
        const response = await fetch(
          `${process.env.REACT_APP_Baseurl}/admin/content-classification/index`,
          { headers: headers }
        );
        const resData = await response.json();
        if (resData?.status === true) {
          const options = resData.AllClassification.map((item) => ({
            value: item.title,
            label: item.title + " - " + item.description,
          }));
          setClassificationOptions(options);
        }
      } catch (error) {
        console.error("Error fetching classifications:", error);
      }
    };

    const getUser = async () => {
      const reqData = await fetch(
        `${process.env.REACT_APP_Baseurl}/admin/age-category/edit/${id}`,
        { headers: headers }
      );

      const resData = await reqData?.json();
      var res = resData?.Age_Category;
      setEditUser(res);
      if (res?.rating_logo_url) {
        setLogoPreview(res.rating_logo_url);
      }

      if (res?.content_classification) {
        const selected = res.content_classification.split(', ').map(item => ({
          value: item,
          label: item // Label will be updated by options if matched, but value is what matters for saving back
        }));
        setSelectedClassifications(selected);
      }
    };

    fetchClassifications();
    getUser();
  }, []);

  const handleClassificationChange = (selected) => {
    setSelectedClassifications(selected || []);
    const titles = (selected || []).map(item => item.value).join(', ');
    setEditUser(prev => ({ ...prev, content_classification: titles }));
  };

  const handleInput = (e) => {
    const { name, value } = e.target;
    setEditUser((prevEditUser) => ({
      ...prevEditUser,
      [name]: value,
    }));

    setValidationMessageage("");
    setIsValidationHiddenage(true);
    setEditUser({ ...editUser, [e.target.name]: e.target.value });
  };

  const handleInputenable = (e) => {
    if (e.target.checked === true) {
      setEditUser({ ...editUser, [e.target.name]: 1 });
    } else {
      setEditUser({ ...editUser, [e.target.name]: 0 });
    }
  };
  const handleFileChange = (e) => {
    const file = e.target.files[0];
    if (file) {
      setRatingLogo(file);
      setLogoPreview(URL.createObjectURL(file));
    }
  };

  const handleClearFile = () => {
    setRatingLogo(null);
    setLogoPreview(null);
  };

  const [validationMessageage, setValidationMessageage] = useState("");
  const [isValidationHiddenage, setIsValidationHiddenage] = useState(true);

  const ageInputRef = useRef(null);

  const [processing, setProcessing] = useState(false);
  const [showOverlay, setShowOverlay] = useState(false);

  const handleUpdate = async (e) => {
    let focusInputRef = null;
    const trimmedEditAge = editUser?.age?.trim();

    if (trimmedEditAge === "") {
      setValidationMessageage("Age cannot be empty.");
      setIsValidationHiddenage(false);
      focusInputRef = ageInputRef;
    }

    if (focusInputRef) {
      focusInputRef.current.focus();
      return;
    }

    e.preventDefault();

    const editInputvalue = {
      id: editUser?.id,
      age: editUser?.age,
      slug: editUser?.slug,
      active: editUser?.active,
      content_classification: editUser?.content_classification,
    };

    let firstApiStatus = false;
    let resultapi = null;
    let resjson = null;
    setProcessing(true);
    setShowOverlay(true);

    try {
      const res = await fetch(
        `${process.env.REACT_APP_Baseurl}/admin/age-category/update/${id}`,
        {
          method: "POST",
          headers: headers,
          body: JSON.stringify(editInputvalue),
        }
      );

      const resjson = await res.json();

      if (resjson?.status === true) {
        // If a logo is selected, upload it
        if (ratingLogo) {
          const imageFormData = new FormData();
          imageFormData.append('modelName', 'AgeCategory');
          imageFormData.append('id', id);
          imageFormData.append('imageFields[]', 'rating_logo');
          imageFormData.append('rating_logo', ratingLogo);

          await fetchRequest({
            method: 'POST',
            url: globalImageUplaodAPI(),
            data: imageFormData,
          });
        }
        // ✅ Success Toast
        toast.success("Update successful!", {
          autoClose: 3000,
        });

        setTimeout(() => {
          navigate("/age/index");
        }, 3000);
      } else {
        // ❌ Error Toast (from API response)
        toast.error(resjson.message || "Update failed!", {
          autoClose: 3000,
        });
        setIsValidationHiddenage(false);
      }
    } catch (error) {
      // ❌ Network Error Toast
      toast.error("Network error occurred!", {
        autoClose: 3000,
      });
      console.error("Error:", error);
    } finally {
      setProcessing(false);
      setShowOverlay(false);
    }
  };

  return (
    <>
      <AdminBackNavigation path="/age/index" text="Back" />
      <div className=" m-0 p-0">
        <div className="">
          <section className="container-fluid">
            <div className="col-lg-12 row py-3">
              <div className="col-6 col-sm-6 col-lg-6">
                <h3>Edit Age Category</h3>
              </div>
              <div className="col-6 col-sm-6 col-lg-6">
                <div className="text-end">
                  <button onClick={handleUpdate} className="button-bg-color theme-button-text-color admin-button-text rounded-3 py-2 px-3">
                    Update Age
                  </button>
                </div>
              </div>
            </div>

            <div>
              {showOverlay && <Response_Processing></Response_Processing>}
            </div>

            <div className="row col-lg-12 ">
              <div className=" col-sm-6 col-md-6 col-lg-6 ">
                <div className="card p-3">
                  <h5 className="theme-text-color theme-border-secondary-color pb-3 mb-3 mt-0">Create Age</h5>
                  <div className=" text-start">
                    <p className="mandatorySimple theme-text-color mt-0 admin-input-title d-block position-relative">Age</p>
                    <div className="mt-2">
                      <input
                        type="text"
                        className="rs-input form-control-lg custom-input  custom-input-border w-100 custom-placeholder bg-transparent  theme-text-color mb-3"
                        id="age"
                        name="age"
                        onChange={handleInput}
                        value={editUser?.age}
                        ref={ageInputRef}
                      />
                    </div>
                    <span className="errorred">
                      {!isValidationHiddenage && <p>{validationMessageage}</p>}
                    </span>
                  </div>

                  <div className="text-start mt-3">
                    <MessageLabel text="Rating Logo" />
                    <AdminImageUploadZone
                      onChange={handleFileChange}
                      selectedFile={ratingLogo}
                      uploadedImage={logoPreview}
                      onDelete={handleClearFile}
                      name="rating_logo"
                      id={editUser?.id}
                      idAttribute="rating_logo"
                    />
                  </div>
                </div>

                {/* <div className="text-start mb-3">
                  <button onClick={handleUpdate} className="btn btn-primary">
                    Save Age
                  </button>
                </div> */}
              </div>

              {/* Second Part of Section  */}

              <div className=" col-sm-6 col-md-6 col-lg-6">
                <div className="card p-3 mt-3">
                  <h5 className="theme-text-color theme-border-secondary-color pb-3 mb-3 mt-0">Content Classification</h5>
                  <div className="text-start">
                    <MessageLabel text="Classification" />
                    <div className="mt-2">
                      <Select
                        isMulti
                        options={classificationOptions}
                        value={selectedClassifications}
                        onChange={handleClassificationChange}
                        className="basic-multi-select"
                        classNamePrefix="select"
                        placeholder="Select Classifications"
                      />
                    </div>
                  </div>
                </div>
                <div className="card p-3">
                  <h5 className="theme-text-color theme-border-secondary-color pb-3 mb-3 mt-0">Status Setting</h5>

                  <div className="d-flex justify-content-between mb-2 ">
                    <div className="col-6 col-md-6 pe-2">
                      <MessageLabel text={"Status"} />
                    </div>
                    <div className="col-6 col-md-6 ps-2 text-end">
                      <AdminSwitch name={'active'} checked={editUser?.active == 1} onChange={(e) => handleInputenable(e, editUser)} id={editUser?.active} />
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </section>
        </div>
      </div>

    </>
  );
}

export default EditManageAge;
